/**
 * Prefills hidden UTM fields on newsletter webforms from URL query parameters.
 * No cookies; no external libraries.
 *
 * @see paragraph--newsletter-signup.html.twig (.zk-newsletter-webform)
 */
export function initZkNewsletterUtm() {
  const params = new URLSearchParams(window.location.search);
  const keys = ['utm_source', 'utm_medium', 'utm_campaign'];

  document.querySelectorAll('.zk-newsletter-webform form.webform-submission-form').forEach((form) => {
    keys.forEach((key) => {
      if (!params.has(key)) {
        return;
      }
      const input = form.querySelector(`input[name="${key}"]`);
      const val = params.get(key);
      if (input && val !== null && input.value === '') {
        input.value = val;
      }
    });
  });
}
